/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seconds: NonNullable<unknown> }} Refusal_Discord_Busy_OneInputs */



/**
* | output |
* | --- |
* | "Discord asked us to slow down. Try again in {seconds} second." |
*
* @param {Refusal_Discord_Busy_OneInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const refusal_discord_busy_one = /** @type {((inputs: Refusal_Discord_Busy_OneInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Refusal_Discord_Busy_OneInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`Discord попросил сбавить темп. Попробуйте снова через ${i?.seconds} секунду.`)
	return /** @type {LocalizedString} */ (`Discord asked us to slow down. Try again in ${i?.seconds} second.`)
});